import { apiClient } from 'Helpers/network';

/**
 * The item tags endpoint for one item. The mount supplies the URL with an EXPENSE_ID placeholder.
 */
export function budgetTagsItemUrl(template, expenseId, packId = null) {
    const url = new URL(template.replace('EXPENSE_ID', expenseId), window.location.origin);
    if (packId) {
        url.searchParams.set('pack_id', packId);
    }

    return url.toString();
}

/**
 * The editor config, labels and grid cell of an item: { form, labels, cell }.
 */
export function fetchItemBudgetTags(template, expenseId, packId = null) {
    return apiClient.get(budgetTagsItemUrl(template, expenseId, packId)).then((response) => response.data.data);
}

/**
 * Saves an item's tags from the editor's { overrides, rows } and resolves with { form, labels, cell }.
 */
export function saveItemBudgetTags(template, expenseId, value, packId = null) {
    return apiClient
        .put(budgetTagsItemUrl(template, expenseId), {
            overrides_budget_tags: value.overrides,
            budget_tags: value.rows,
            pack_id: packId,
        })
        .then((response) => response.data.data);
}

export function budgetTagsErrorMessages(error) {
    const data = error?.response?.data || {};
    const fieldErrors = Object.values(data.errors || {}).flat();

    return fieldErrors.length > 0 ? fieldErrors : [data.message || $t('Something went wrong. Please try again.')];
}
